module.exports = __webpack_public_path__ + "static/media/template_zuzel.f26a0cf6.png";